import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Button, IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import useTable from '../../useTable';
import SearchIcon from '@material-ui/icons/Search';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import Popup from '../../Popup';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../CustomAlert';
import EditIcon from '@material-ui/icons/Edit';
import EyeIcon from '@material-ui/icons/RemoveRedEye';
import { Helmet } from 'react-helmet';
import { getProductAndPurchaseDocumentWithUserId } from '../../../Backend/firebase/product-and-purchase';
import ProductAndPurchaseFilter from './ProductAndPurchaseFilter';
import UpdateProductAndPurchase from './UpdateProductAndPurchase';
import ViewProductAndPurchase from './ViewProductAndPurchase';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'ProductName', label: 'Product Name', disableSorting: true },
    { id: 'PrimaryPack', label: 'Primary Pack', disableSorting: false },
    { id: 'SecondaryPack', label: 'Secondary Pack', disableSorting: false },
    { id: 'PackConversion', label: 'Pack Conversion', disableSorting: false },
    { id: 'StockAsPerPrimaryPack', label: 'Stock (As per Primary Pack)', disableSorting: false },
    { id: 'MRPAsPerPrimaryPack', label: 'MRP (as per Primary Pack)', disableSorting: false },
    { id: 'SellingPriceAsPerPrimaryPack', label: 'Selling Price (as per Primary pack)', disableSorting: false },
    { id: 'PurchaseDate', label: 'Purchase Date', disableSorting: false },
    { id: 'action', label: 'Action', disableSorting: false },
]

function AllProductAndPurchase() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const [openPopup, setOpenPopup] = useState(false);
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [updatedProductAndPurchaseId, setUpdatedProductAndPurchaseId] = useState('');
    const [uniqueProductAndPurchaseId, setUniqueProductAndPurchaseId] = useState('');
    const history = useHistory();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items.filter(x => x.ProductName.toLowerCase().includes(target.value.toLowerCase()));
                }
            }
        });
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getProductsAndPurchase = await getProductAndPurchaseDocumentWithUserId(userData.uid);
                setRecords(getProductsAndPurchase);
                setIsLoading(false);
            } catch(error) {
                console.log("Error Occur in Get Products And Purchase", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const updateProductAndPurchase = (_id, productAndPurchaseId) => {
        setUniqueProductAndPurchaseId(_id);
        setUpdatedProductAndPurchaseId(productAndPurchaseId);
        setOpenPopup(true);
    };

    const viewProductAndPurchase = (_id, productAndPurchaseId) => {
        setUniqueProductAndPurchaseId(_id);
        setUpdatedProductAndPurchaseId(productAndPurchaseId);
        setOpenViewPopup(true);
    };

    const handleFilters = async (filter) => {
        console.log('Filter Changed => ', filter);
    };

    const refreshData = async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getProductsAndPurchase = await getProductAndPurchaseDocumentWithUserId(userData.uid);
                console.log("getProductsAndPurchase",getProductsAndPurchase)
                setRecords(getProductsAndPurchase);
                setIsLoading(false);
                setNotificationMessage('Products And Purchase data has updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
            } catch(error) {
                console.log("Error Occur in Get Products And Purchase", error)
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndPurchase">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Products And Purchase you have posted till now." />
                            <title>Products And Purchase | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-8">
                                <ProductAndPurchaseFilter handleFilters={handleFilters} refreshData={refreshData} />
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search Products And Purchase..." className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12">
                                {/* <TblContainer>
                                    <TblHead />
                                    <TableBody> */}
                                        {
                                            recordsAfterPagingAndSorting().map(item => (
                                                <>
                                                    <div className="col-lg-4 col-md-4 col-sm-12 topSkills topSkills__productDisplay" key={item.id}>
                                                        <div className="card-events card-products all-products">
                                                            <div className="card-events-body d-flex flex-column background__color position__class">
                                                                <div className="product__edit">
                                                                    <Tooltip title="Edit Product And Purchase" placement="top">
                                                                        <IconButton color="primary"
                                                                            onClick={() => updateProductAndPurchase(item._id, item.uniqueId)}>
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="View Product And Purchase Record" placement="top">
                                                                        <IconButton color="primary"
                                                                            onClick={() => viewProductAndPurchase(item._id, item.uniqueId)}>
                                                                            <EyeIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </div>
                                                                <div className="party-events-details">
                                                                    <h5 className="card-events-title white__color product__mainTitle">{item.ProductName}</h5>
                                                                    <p className="card-events-title white__color">{item?.ProductType}</p>
                                                                    <p className="card-events-title white__color">HSN Code: <b>{item.HSNCode ? `${item.HSNCode}` : 'NA'}</b></p>
                                                                    {item.GSTClass && <p className="card-events-title white__color">GST Class: <b>{item.GSTClass ? `${item.GSTClass}%` : '0'}</b></p>}
                                                                    {item.Discount && <p className="card-events-title white__color">Discount: <b>{item.Discount}</b></p>}
                                                                    {item.PrimaryPack && <p className="card-events-title white__color">Primary Pack: <b>{item.PrimaryPack}</b></p>}
                                                                    {item.MRPAsPerPrimaryPack && <p className="card-events-title white__color">MRP(Primary Pack): <b>{item.MRPAsPerPrimaryPack ? `Rs. ${item.MRPAsPerPrimaryPack}` : 'Rs. 0'}</b></p>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <TableRow key={item.id}>
                                                        <TableCell>{item.ProductName}</TableCell>
                                                        <TableCell>{item.PrimaryPack ? item.PrimaryPack : "NA"}</TableCell>
                                                        <TableCell>{item.SecondaryPack ? item.SecondaryPack : "NA"}</TableCell>
                                                        <TableCell>{item.PackConversion ? item.PackConversion : "NA"}</TableCell>
                                                        <TableCell>{item.StockAsPerPrimaryPack ? item.StockAsPerPrimaryPack : "NA"}</TableCell>
                                                        <TableCell>{item.MRPAsPerPrimaryPack ? `Rs. ${item.MRPAsPerPrimaryPack}` : "NA"}</TableCell>
                                                        <TableCell>{item.SellingPriceAsPerPrimaryPack ? `Rs. ${item.SellingPriceAsPerPrimaryPack}` : "NA"}</TableCell>
                                                        <TableCell>{item?.PurchaseDate ? item.PurchaseDate : "NA"}</TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Edit Product And Purchase Record" placement="top">
                                                                <IconButton color="secondary"
                                                                    onClick={() => updateProductAndPurchase(item._id, item.uniqueId)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="View Product And Purchase Record" placement="top">
                                                                <IconButton color="secondary"
                                                                    onClick={() => viewProductAndPurchase(item._id, item.uniqueId)}>
                                                                    <EyeIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow> */}
                                                </>
                                            ))
                                        }
                                    {/* </TableBody>
                                </TblContainer> */}
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No Products And Purchase Record Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Update Product And Purchase Record" popupSize="lg">
                <UpdateProductAndPurchase _id={uniqueProductAndPurchaseId} productAndPurchaseId={updatedProductAndPurchaseId} setOpenPopup={setOpenPopup} refreshData={refreshData} />
            </Popup>

            <Popup openPopup={openViewPopup} setOpenPopup={setOpenViewPopup} title="View Product And Purchase Record" popupSize="md">
                <ViewProductAndPurchase productAndPurchaseId={updatedProductAndPurchaseId} />
            </Popup>
        </>
    )
}

export default AllProductAndPurchase
